import { useI18n } from 'vue-i18n'

/**
 * 判断主题是否为默认主题
 * @returns
 */
export function isNormalTheme () {
  return process.env.VUE_APP_SKIN_IMAGE === 'e'
}

/**
 * 根据主题生成祝福语
 * @returns
 */
export function generateThemeTitle () {
  const { t } = useI18n()

  return isNormalTheme() ? t('v1.0.defaultTitle') : t('v1.0.holidayTitle')
}
